export const sxPlatesList = {
  title: {
    fontWeight: 700,
    fontSize: { xs: '18px', sm: '25px' },
    lineHeight: 1,
    //mb: { xs: 1, sm: '30px' },
    color: '#000000',
    pl: { sm: 3 },
    textAlign: { xs: 'center', sm: 'start' },
    paddingLeft: { xs: '0px', sm: '0px' },
    paddingTop: { xs: '30px', sm: '30px' },
    paddingBottom: { xs: '20px', sm: '20px' },
  },
  filters: {
    display: 'flex',
    backgroundColor: '#182a5e',
    padding: '25px',
    marginBottom: '20px',
  },
  boxWhite: {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    padding: '8px',
    ml: '15px',
    mr: '12px',
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
